<template>
  <!--begin::Modal-->
  <div
      class="modal fade"
      ref="PermissionModal"
      id="PermissionModal"
      tabindex="-1"
      aria-hidden="true"
  >
    <!--begin::Modal dialog-->
    <div class="modal-dialog modal-dialog-centered mw-650px">
      <!--begin::Modal content-->
      <div class="modal-content">
        <!--begin::Form-->
        <Form
            class="form"
            ref="PermissionModalForm"
            id="PermissionModal_form"
            :validation-schema="validationSchema"
            @submit="submit"
        >
          <!--begin::Modal header-->
          <div class="modal-header" id="PermissionModal_header">
            <!--begin::Modal title-->
            <h2>{{ title }}</h2>
            <!--end::Modal title-->

            <!--begin::Close-->
            <div
                class="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->

          <!--begin::Modal body-->
          <div class="modal-body py-10 px-lg-17">
            <!--begin::Scroll-->
            <div
                class="scroll-y me-n7 pe-7"
                id="PermissionModal_scroll"
                data-kt-scroll="true"
                data-kt-scroll-activate="{default: false, lg: true}"
                data-kt-scroll-max-height="auto"
                data-kt-scroll-dependencies="#PermissionModal_header"
                data-kt-scroll-wrappers="#PermissionModal_scroll"
                data-kt-scroll-offset="300px"
            >
              <div class="row">
                <div class="col-md-12 fv-row">
                  <!--begin::Label-->
                  <label for="title" class="required fs-5 fw-bold mb-2">Title</label>
                  <!--end::Label-->

                  <!--begin::Input-->
                  <Field
                      type="text"
                      id="title"
                      class="form-control form-control-solid"
                      placeholder="Enter title"
                      name="title"
                      v-model.trim="permissionData.title"
                  />
                  <div class="fv-plugins-message-container">
                    <div class="fv-help-block">
                      <ErrorMessage name="title" />
                    </div>
                  </div>
                  <!--end::Input-->
                </div>
              </div>
            </div>
            <!--end::Scroll-->
          </div>
          <!--end::Modal body-->

          <!--begin::Modal footer-->
          <div class="modal-footer flex-center">
            <!--begin::Button-->
            <button
                type="reset"
                id="PermissionModal_cancel"
                class="btn btn-white me-3"
                data-bs-dismiss="modal"
            >
              Discard
            </button>
            <!--end::Button-->

            <!--begin::Button-->
            <button
                :disabled="permissionData.title == ''"
                type="submit"
                id="PermissionModal_submit"
                class="btn btn-primary"
            >
              <span class="indicator-label"> Submit </span>

              <span class="indicator-progress">
                Please wait...
                <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                ></span>
              </span>
            </button>
          </div>
          <!--end::Modal footer-->
        </Form>
        <!--end::Form-->
      </div>
    </div>
  </div>

  <!--end::Modal - New Address-->
</template>

<script lang="js">
import { defineComponent } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { Modal } from 'bootstrap';

function initialPermissionData() {
  return {
    title: ""
  }};

export default defineComponent({
  name: "PermissionModal",
  components: {
    ErrorMessage,
    Field,
    Form
  },
  props: {
    currentlySelectedPermission: Object,
    action : String,
    title : String
  },
  mounted() {
    this.modal = new Modal(this.$refs.PermissionModal)
  },
  data() {
    return {
      validationSchema: Yup.object().shape({
        title: Yup.string()
            .required()
            .label("Title")
      }),
      permissionData: initialPermissionData(),
      modal: null
    };
  },
  methods: {
    submit() {
      this.validationSchema.isValid(this.permissionData).then((validationResult) => {
        if(validationResult){
          this.modal.hide();
          // eslint-disable-next-line @typescript-eslint/camelcase
          this.$emit("saveChanges", {payload : this.permissionData, action : this.action});
        }
      })
    },
  },
  watch: {
    currentlySelectedPermission() {
      if(this.action == "edit" ){
        this.permissionData.title = this.currentlySelectedPermission.title
      }
    },
    title() {
      if(this.action !== "edit") this.permissionData = initialPermissionData();
      this.$refs.PermissionModalForm.resetForm(null);
    }
  }
});
</script>
